const actions= Object.freeze({
  add: 'add',
  remove: 'remove'
})

const timeTs = Object.freeze({
  oneYear: 31556926,
})

const tagType = Object.freeze({
  tag: 'tag',
  difficulty: 'difficulty',
  duration: 'duration',
  serving: 'serving',
  domain: 'domain',
  skill: 'skill',
  intersection: 'intersection',
  dish: 'dish',
  recipe: 'recipe'
})

export {
  actions,
  tagType,
  timeTs
}




// WEBPACK FOOTER //
// ./src/libs/consts.js